import React from 'react';
import styled from 'styled-components';
import { CredusButton, CredusText } from 'ui';
import { NoDataIcon } from '../../../../assets/images/svgs';

interface CreateFirstTestProps {
  setCreateTest: React.Dispatch<React.SetStateAction<boolean>>;
}

const CreateFirstTest = ({ setCreateTest }: CreateFirstTestProps) => {
  const handleClick = () => {
    setCreateTest(true);
  };
  return (
    <Container>
      <CredusButton size="medium" onClick={handleClick}>
        Create Test
      </CredusButton>
      <Div>
        <NoDataIcon />
        <CredusText size="lg" weight="regular">
          No available test
        </CredusText>
      </Div>
    </Container>
  );
};

export default CreateFirstTest;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7rem;
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;
